'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgCamera48 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { d: "M0 .5h48v47H0z" }), jsxRuntime.jsx("path", { d: "M34.714 35.016H13.286c-1.184 0-2.143-.94-2.143-2.099V18.23c0-1.159.96-2.098 2.143-2.098h4.285l2.143-3.148h8.572l2.143 3.148h4.285c1.184 0 2.143.94 2.143 2.098v14.687c0 1.16-.96 2.099-2.143 2.099zM24 29.77c2.663 0 4.821-2.114 4.821-4.72 0-2.608-2.158-4.722-4.821-4.722s-4.821 2.114-4.821 4.721S21.337 29.77 24 29.77z", stroke: "currentColor" })] }))] })));
};

exports.default = SvgCamera48;
